import { remove } from 'js-cookie'
import config from '../config'

export const WFE_TOKEN_KEY = 'wfeToken'

export const getJwt = () => localStorage.getItem(WFE_TOKEN_KEY)

export const setJwt = (jwt: string) => localStorage.setItem(WFE_TOKEN_KEY, jwt)

export const clearJwt = () => localStorage.removeItem(WFE_TOKEN_KEY)

export const clearLegacyCookie = () =>
  remove(WFE_TOKEN_KEY, {
    path: '/',
    domain: config.getCookieDomain() as string,
  })
